document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.gg-numer').forEach(initGGNumerSection);
});
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.gg-numer');
    if (el) initGGNumerSection(el);
  });
}

function initGGNumerSection(root) {
  if (root.dataset.ggInit) return;
  root.dataset.ggInit = '1';

  /* ---------------- Scroll reveal ---------------- */
  var revealEls = root.querySelectorAll('[data-gg-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('gg-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('gg-in'); });
  }

  /* ---------------- Smooth scroll ---------------- */
  root.querySelectorAll('[data-gg-scroll-target]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = root.querySelector(btn.dataset.ggScrollTarget) ||
        document.querySelector(btn.dataset.ggScrollTarget);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
  root.querySelectorAll('a[href^="#gg-numer-form"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---------------- Sticky mobile bar ---------------- */
  var sticky = root.querySelector('[data-gg-sticky]');
  var hero = root.querySelector('.gg-numer-hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var heroIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('gg-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    heroIO.observe(hero);
  }

  /* ---------------- Wizard ---------------- */
  var form = root.querySelector('.gg-numer-wizard');
  if (!form) return;

  var steps = Array.prototype.slice.call(form.querySelectorAll('[data-gg-step]'));
  var progressFill = form.querySelector('[data-gg-progress-fill]');
  var stepLabels = form.querySelectorAll('[data-gg-step-label]');
  var current = 1;

  function showStep(n) {
    current = n;
    steps.forEach(function (s) {
      s.classList.toggle('is-active', parseInt(s.dataset.ggStep, 10) === n);
    });
    stepLabels.forEach(function (l) {
      l.classList.toggle('is-active', parseInt(l.dataset.ggStepLabel, 10) <= n);
    });
    if (progressFill) progressFill.style.width = (n / steps.length * 100) + '%';
    if (n === steps.length) buildSummary();
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function validateStep(stepEl) {
    var valid = true;
    stepEl.querySelectorAll('input[required], select[required], textarea[required]').forEach(function (input) {
      var field = input.closest('.gg-numer-field');
      var ok = input.checkValidity() && input.value.trim() !== '';
      if (field) field.classList.toggle('gg-invalid', !ok);
      if (!ok) valid = false;
    });
    return valid;
  }

  form.querySelectorAll('[data-gg-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var activeStep = form.querySelector('.gg-numer-step.is-active');
      if (!validateStep(activeStep)) return;
      if (current < steps.length) showStep(current + 1);
    });
  });
  form.querySelectorAll('[data-gg-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (current > 1) showStep(current - 1);
    });
  });

  /* Clear invalid state as user types */
  form.querySelectorAll('input, select, textarea').forEach(function (input) {
    input.addEventListener('input', function () {
      var field = input.closest('.gg-numer-field');
      if (field) field.classList.remove('gg-invalid');
    });
  });

  /* "I don't know my time of birth" */
  var timeUnknown = form.querySelector('[data-gg-time-unknown]');
  var tobInput = form.querySelector('input[name="properties[Time of Birth]"]');
  if (timeUnknown && tobInput) {
    timeUnknown.addEventListener('change', function () {
      if (timeUnknown.checked) {
        tobInput.value = '';
        tobInput.disabled = true;
        tobInput.placeholder = 'Unknown';
      } else {
        tobInput.disabled = false;
      }
    });
  }

  /* Review summary */
  function buildSummary() {
    var summary = form.querySelector('[data-gg-summary]');
    if (!summary) return;
    var get = function (name) {
      var el = form.querySelector('[name="properties[' + name + ']"]');
      if (!el) return '';
      if (el.disabled) return 'Not provided';
      return el.value || '—';
    };
    summary.innerHTML =
      '<div><strong>Name:</strong> ' + escapeHtml(get('Full Name')) + '</div>' +
      '<div><strong>Email:</strong> ' + escapeHtml(get('Email')) + '</div>' +
      '<div><strong>Phone:</strong> ' + escapeHtml(get('Phone')) + '</div>' +
      '<div><strong>Date of Birth:</strong> ' + escapeHtml(get('Date of Birth')) + '</div>' +
      '<div><strong>Time of Birth:</strong> ' + escapeHtml(get('Time of Birth')) + '</div>' +
      '<div><strong>Place of Birth:</strong> ' + escapeHtml(get('Place of Birth')) + '</div>';
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  /* ---------------- Submit: add to cart, redirect to checkout ---------------- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var finalStep = form.querySelector('.gg-numer-step[data-gg-step="' + steps.length + '"]');
    if (!validateStep(finalStep)) return;

    var consent = form.querySelector('[data-gg-consent]');
    if (consent && !consent.checked) {
      consent.closest('.gg-numer-checkbox').style.color = '#c0392b';
      return;
    }

    var submitBtn = form.querySelector('[data-gg-submit]');
    var errorEl = form.querySelector('[data-gg-form-error]');
    if (errorEl) errorEl.hidden = true;
    if (submitBtn) {
      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;
    }

    var properties = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      if (input.disabled) return;
      var key = input.name.match(/properties\[(.+)\]/)[1];
      if (input.value) properties[key] = input.value;
    });

    var payload = {
      items: [
        {
          id: parseInt(form.dataset.variantId, 10),
          quantity: 1,
          properties: properties
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Could not add to cart'); });
        return res.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        if (submitBtn) {
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
        }
        if (errorEl) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
        }
      });
  });
}